import { useContext, useEffect } from 'react';
import { Box, Grid, Paper, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { DataDispatchContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function EmuBanner() {
  const navigate = useNavigate()
  const dispatch: any = useContext(DataDispatchContext)

  useEffect(()=>{
    sendViewAnalytics('/dashboard', {
            domain: analyticsDomain.dashboard,
            name: analyticsPage.emuCustomer
        })
  },[])

  function handleContactUs() {
    dispatch({
      type: 'setAcctSelected',
      acctSelected: 'help'
    })
    sendClickAnalytics('/dashboard', {
      domain: analyticsDomain.dashboard,
      name: analyticsCta.emuCustomerContactUs,
      metadata: {},
    })
    navigate('/profile')
  }
  return (
    <Grid container id="emuBanner" 
    direction="row" display="flex"  
    justifyContent="flex-end" 
    spacing={custom.spacing.xxs}
    width= "100%">
      <Paper id="systemError" elevation={0} 
            sx={{ 
              borderRadius: custom.corners5, 
              border: custom.border,
              width: "100%",
              backgroundColor: 'sz.colors.surfaceAccent',
              my: custom.spacing.md,
              ml: custom.spacing.sm,
              p: custom.spacing.md,
            }}
        >
          <Box component="img"
                src="images/SolarRoofEMU.svg"
              />  
          <Typography component="p" mt={custom.spacing.xxs}
              variant="szHeading.Bold.Medium">
              Time for an upgrade
          </Typography>
          <Box>
            <Typography component="p" mt={custom.spacing.xxs}
                variant="szBody.Regular.Medium">
                Sorry, the new monitoring dashboard isn't available for your solar energy system just yet. 
                You can still access the Refer-a-Friend Programme, but to be able to access our new monitoring system, we need to upgrade your hardware.
                <br/> <br />
                Get in touch with us through the button below, and we’ll schedule an onsite meeting to upgrade your system free of charge. 
            </Typography>
          </Box>
          <Button variant="contained" id="contactUsButton"
              onClick={handleContactUs}
              sx={{ mt: custom.spacing.sm, 
                px: custom.spacing.sm, 
                py: custom.spacing.xs }}>
            <Typography variant="szBody.Regular.Medium"
                color="#FFF">
                Contact us
            </Typography>
          </Button>
      </Paper>
    </Grid>
  )
}
